import { EmptyState } from './EmptyState/EmptyState';
import { PlantIcon } from '../Icons/CardsIcons';

interface TableEmptyStateProps {
	title: string;
	subtitle: string;
}

export const TableEmptyState = ({ title, subtitle }: TableEmptyStateProps) => (
	<EmptyState icon={<PlantIcon />} title={title} description={subtitle} />
);
